import React, {useEffect, useState} from "react"
import StandardList from "../../listing/list.component"
import {defineMessages, FormattedMessage, injectIntl} from "react-intl"
import Pagination from "../../listing/pagination.component"
import {DebounceInput} from "react-debounce-input"
import {connect, ConnectedProps} from "react-redux"
import IntlProps from "../../../state/helpers/IntlProps"
import {getCustomerIdSelection} from "../../../state/selection/selectionSelectors"
import {
    editCustomerIdSelection,
    addMultipleCustomerIdsSelection,
    clearCustomerSelection, removeMultipleCustomerIdsSelection,
} from "../../../state/selection/selectionActions"
import LabelSelect from "../../label/selection.component"
import SearchService from "../../../state/search/SearchService"

type OwnProps = object

const messages = defineMessages({
    "modal_text_placeholder": {
        id: "price_list.customer_listing.search_placeholder",
        defaultMessage: "Search for customers",
    },
    "label_filter_placeholder": {
        id: "quote.add_item_modal.placeholder.label_filter",
        defaultMessage: "Label filters",
    },
})

const SimpleCustomerSelectComponent = (props: Props & IntlProps) => {
    const [activePage, setActivePage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [labels, setLabels] = useState([])
    const [searchListing, setSearchListing] = useState({
        customerListing: [],
        totalItemsCount: 0,
        keyword: "",
    })

    useEffect(() => {
        void refreshSearch(searchListing.keyword)
    }, [activePage, pageSize, labels])

    const refreshSearch = async (keyword) => {
        const res = await SearchService.getCustomers(keyword, activePage, pageSize, labels)
        setSearchListing({
            ...searchListing,
            totalItemsCount: res.metadata.totalItemsCount,
            customerListing: res.data,
        })
    }

    const handleSelectAll = async (isAllSelected) => {
        if (isAllSelected) {
            const getAllCustomerIdsPromise = await SearchService.getCustomerIds(searchListing.keyword, 1, 1000, labels)
            props.addMultipleCustomerIdsSelection(getAllCustomerIdsPromise)
        } else {
            props.clearCustomerSelection()
        }
    }

    const handlePageSelect = (isSelected): void => {
        if (Object.values(isSelected)[0]) {
            props.addMultipleCustomerIdsSelection(Object.keys(isSelected))
        } else {
            props.removeMultipleCustomerIdsSelection(Object.keys(isSelected))
        }
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-6 col-12">
                    <DebounceInput
                        minLength={0}
                        debounceTimeout={500}
                        onChange={e => refreshSearch(e.target.value)}
                        value={searchListing.keyword}
                        type="text"
                        className="form-control"
                        placeholder={props.intl.formatMessage(messages["modal_text_placeholder"])}
                    />
                </div>
                <div className="col-md-6 col-12">
                    <LabelSelect
                        placeholder={props.intl.formatMessage(messages["label_filter_placeholder"])}
                        value={labels}
                        type={"customer-type"}
                        onChange={e => setLabels(e)}
                        multi={true}
                    />
                </div>
            </div>

            <StandardList
                smallLine={true}
                className="row pt-3"
                headers={headers()}
                rows={searchListing.customerListing.map(contact => row(contact, props.customerIdSelection))}
                pageSize={pageSize}
                totalItemsCount={searchListing.totalItemsCount}
                selectable={true}
                onRowClick={metadata => {
                    props.editCustomerIdSelection(metadata.contactId)
                }}
                onRowSelect={contactId => {
                    props.editCustomerIdSelection(contactId)
                }}
                onPageSelect={pageSelection => {
                    handlePageSelect(pageSelection)
                }}
                onSelectAll={allSelected => {
                    void handleSelectAll(allSelected)
                }}
                tableClassName={"table-hover"}
            />

            <Pagination
                activePage={activePage}
                totalItemsCount={searchListing.totalItemsCount}
                onChange={page => {
                    setActivePage(page)
                }}
                onPageSizeChange={size => {
                    setPageSize(size)
                }}
                pageSize={pageSize}
                showPageSize={true}/>
        </div>

    )
}

const headers = () => {
    return [
        <FormattedMessage
            key="price_list.customer_list.header_name"
            id="price_list.customer_list.header_name"
            defaultMessage="Name"
        />,
        <FormattedMessage
            key="price_list.customer_list.header_email"
            id="price_list.customer_list.header_email"
            defaultMessage="Email address"
        />,
    ]
}

const row = (contact, customerIdSelection: Set<string>) => {
    return {
        rowId: contact.id,
        data: [
            contact.name,
            contact.email,
        ],
        metadata: {
            contactId: contact.id
        },
        selected: customerIdSelection.has(contact.id),
    }
}


const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        customerIdSelection: getCustomerIdSelection(state)
    }
}
const mapDispatch = {
    editCustomerIdSelection,
    addMultipleCustomerIdsSelection,
    removeMultipleCustomerIdsSelection,
    clearCustomerSelection,
}

const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(SimpleCustomerSelectComponent))


// WEBPACK FOOTER //
// ./src/common/contact/components/SimpleCustomerSelectComponent.tsx